import httpClient from '../../../clientSideServices/http';
import { IPrivateAppointmentData } from '../../../interfaces';

export const bookPrivateAppointment = (
  data: IPrivateAppointmentData
) => {
  return httpClient.post('/api/bookPrivateAppointment', data);
};
